"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.featuresToggle = exports.fetchFeatures = exports.getFeaturesCache = exports.setFeaturesCache = exports.init = void 0;
var axios_1 = __importDefault(require("axios"));
var appId = "";
var firebase;
var firebaseremote;
var KEY_FEATURES_CACHE = "FeatureToggle_fetchFeatures";
var featuresToggle = {};
exports.featuresToggle = featuresToggle;
var init = function (initialConfig) {
    appId = initialConfig.appId;
    var headers = { "x-goog-api-key": initialConfig.apiKey };
    var url = ".googleapis.com/v1/projects/".concat(initialConfig.projectId);
    firebase = axios_1["default"].create({
        baseURL: "https://firebaseinstallations".concat(url),
        headers: headers
    });
    firebaseremote = axios_1["default"].create({
        baseURL: "https://firebaseremoteconfig".concat(url),
        headers: headers
    });
};
exports.init = init;
var getToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, firebase.post("/installations", {
                        appId: appId,
                        sdkVersion: "7.8.1"
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data.authToken.token];
            case 2:
                e_1 = _a.sent();
                console.log("Erro:", JSON.stringify(e_1));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, ""];
        }
    });
}); };
var setFeaturesCache = function (features) {
    return localStorage.setItem(KEY_FEATURES_CACHE, JSON.stringify(features));
};
exports.setFeaturesCache = setFeaturesCache;
var getFeaturesCache = function () {
    return JSON.parse(localStorage.getItem(KEY_FEATURES_CACHE) || "") || [];
};
exports.getFeaturesCache = getFeaturesCache;
var fetchFeatures = function (useCache) {
    if (useCache === void 0) { useCache = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var features, token, data_1, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    features = useCache ? (0, exports.getFeaturesCache)() : [];
                    if (!!useCache) return [3 /*break*/, 3];
                    return [4 /*yield*/, getToken()];
                case 1:
                    token = _a.sent();
                    return [4 /*yield*/, firebaseremote.post("/namespaces/firebase:fetch", {
                            app_instance_id: "dVGEc1L_t164GjU08Bocsd5",
                            app_instance_id_token: token,
                            app_id: appId
                        })];
                case 2:
                    data_1 = (_a.sent()).data;
                    exports.featuresToggle = featuresToggle = data_1.entries;
                    features = Object.keys(data_1.entries).reduce(function (result, key) {
                        if (data_1.entries[key] === "true") {
                            result.push(key);
                        }
                        return result;
                    }, []);
                    _a.label = 3;
                case 3: return [2 /*return*/, features];
                case 4:
                    e_2 = _a.sent();
                    console.log("Erro:", e_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, []];
            }
        });
    });
};
exports.fetchFeatures = fetchFeatures;
//# sourceMappingURL=firebase.js.map